// src/components/TPP/TPPCell/providers/TPPCellLinkModalProvider.tsx
import React, { createContext, PropsWithChildren, useContext } from 'react'
import useTPPCellLinkModal from './hooks/useTPPCellLinkModal'

const TPPCellLinkModalContext = createContext<ReturnType<typeof useTPPCellLinkModal> | undefined>(undefined)

const TPPCellLinkModalProvider = ({ children }: PropsWithChildren<{}>) => {
    const cellLinkModal = useTPPCellLinkModal()

    return <TPPCellLinkModalContext.Provider value={cellLinkModal}>{children}</TPPCellLinkModalContext.Provider>
}

export const useTPPCellLinkModalContext = () => {
    const context = useContext(TPPCellLinkModalContext)

    if (!context) throw new Error('useTPPCellLinkModalContext must be used within TPPCellLinkModalProvider')

    return context
}

export default TPPCellLinkModalProvider
